import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Hero from "@/components/feature/Hero";
import Values from "@/components/feature/Values";
import FeaturedSpotlight from "@/components/feature/FeaturedSpotlight";
import BrandStory from "@/components/feature/BrandStory";
import Collections from "@/components/feature/Collections";
import ClosingCTA from "@/components/feature/ClosingCTA";
import Footer from "@/components/feature/Footer";

export default function Home() {
  const location = useLocation();

  // If the URL has a hash (e.g. /#collections from a "Shop the collection" CTA),
  // smooth-scroll to that section. Plain "/" scroll-to-top is handled globally
  // by <ScrollToTop /> in App.tsx.
  useEffect(() => {
    if (!location.hash) return;
    const el = document.querySelector(location.hash);
    if (!el) return;
    const t = setTimeout(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => clearTimeout(t);
  }, [location.key, location.hash]);

  return (
    <main className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar transparentOverHero />
      <Hero />
      <Values />
      <FeaturedSpotlight />
      <BrandStory />
      <Collections />
      <ClosingCTA />
      <Footer />
    </main>
  );
}